module.exports = __webpack_public_path__ + "img/51.e67b4d2a.svg";